import Modal from '@shared/Modal'
import { useTranslation } from 'react-i18next'
import Button from 'src/components/Button'
import styled from 'styled-components'

type Props = {
  onLeave: () => void
  onCancel: () => void
}

function ConfirmUpdateModal({ onCancel, onLeave }: Props) {
  const { t } = useTranslation()

  return (
    <StyledModal
      width="400px"
      open
      onCancel={onCancel}
      footer={
        <>
          <span />
          <div>
            <Button.Quit onClick={onLeave} />
            <Button.Continue onClick={onCancel} className="ml-16" />
          </div>
        </>
      }>
      <span className="text-white">
        {t('common:not yet been saved, discard your changes')}
      </span>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    .ant-modal-close {
      padding: 16px;
      display: block;
      position: inherit;
      float: right;
      .ant-modal-close-x {
        width: 32px;
        height: 32px;
        line-height: 25px;
        font-size: 23px;
      }
    }
    .ant-modal-body {
      clear: both;
      text-align: center;
      font-size: 15px;
      font-weight: 500;
      padding: 16px;
      margin-bottom: 23px;
    }
  }
  .ant-modal-footer {
    padding: 24px 32px;
    border: 0;
  }
`

export default ConfirmUpdateModal
